import logo from './logo.svg';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import PageNavigation from './navigation/PageNavigation';
import Navbar from './navigation/Navbar';
import Promo from './navigation/Promo';
import ScrollTop from './components/ScrollTop';

function App() {
	return (
		<BrowserRouter>
			<Navbar />
			<PageNavigation />
			<ScrollTop />
		</BrowserRouter>
	);
}

export default App;
